export const MODAL_STATE = 'MODAL_STATE';

export const modalState = (status) => {
  return {
      type: MODAL_STATE,
      status: status
  };
}